import { createContext } from 'react'
import type {
  AuthUser,
  Membership,
  Organization,
  Profile,
} from '@zetyar/domain'

export interface AppState {
  user: AuthUser | null
  profile: Profile | null
  currentOrganization: Organization | null
  currentMembership: Membership | null
  organizations: Organization[]
  permissions: string[]
  isLoading: boolean
  selectOrganization: (orgId: string) => void
  refreshOrganizations: () => Promise<void>
  signIn: (email: string, password?: string) => Promise<Profile | null>
  signOut: () => Promise<void>
  updateProfile: (preferredName: string, phone: string | null, avatarUrl: string | null, rut: string | null) => Promise<void>
  updateOrganization: (
    name: string,
    timezone: string,
    currency: string,
    logoUrl?: string | null,
    features?: Record<string, boolean>,
  ) => Promise<void>
}

export const AppContext = createContext<AppState | undefined>(undefined)
